import { h } from 'preact';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Skeleton from '@mui/material/Skeleton';

export function LazyRpmIssueRecord(_props) {
  return (
    <TableRow hover>
      <TableCell>
        <Skeleton width={240} />
      </TableCell>
      <TableCell>
        <Skeleton width={10} />
      </TableCell>
      <TableCell>
        <Skeleton width={10} />
      </TableCell>
      <TableCell>
        <Skeleton width={10} />
      </TableCell>
      <TableCell>
        <Skeleton variant="circular" width={24} height={24} />
      </TableCell>
    </TableRow>
  );
}
